import React from "react";
import { Navigate, Route, Routes } from "react-router";
import InvitePage from "./InvitePage";
import InviteCreateAccount from "./InviteCreateAccountPage";
import InviteLoginPage from "./InviteLoginPage";
import InviteAcceptPage from "./InviteAcceptPage";

const InviteShell: React.FC = (): React.ReactElement => {
  return (
    <Routes>
      <Route path="register" element={<InviteCreateAccount />} />
      <Route path="login" element={<InviteLoginPage />} />
      <Route path="accept" element={<InviteAcceptPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
      <Route index element={<InvitePage />} />
    </Routes>
  );
};

export default InviteShell;
